import { classNames } from "primereact/utils";
import { ProgressSpinnerPassThroughOptions } from "primereact/progressspinner";


export const progressspinner: ProgressSpinnerPassThroughOptions = {
    root: ({ props }: any) => ({
        className: classNames('relative mx-auto w-28 h-28 inline-block', 'before:block before:pt-full')
    }),
    spinner: (_: any) => ({
        className: classNames('absolute top-0 bottom-0 left-0 right-0 m-auto w-full h-full transform origin-center animate-spin')
    }),
    circle: (_: any) => ({
        className: classNames('text-red-500 progress-spinner-circle')
    })
}
